import React from "react";

const Errorpage = () => {
    return (
        <div>
            <p>This page is not quite ready! Please return soon!</p>
        </div>
    )
}

export default Errorpage;